import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { NeonButton } from './ui/NeonButton';
import { Users } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden" data-id="element-105">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[#0A0A0A] z-0" data-id="element-106">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-[#FF6B35]/10 blur-[120px] rounded-full opacity-40 pointer-events-none" data-id="element-107" />
        {/* Grain Texture Overlay */}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
      }} data-id="element-108"></div>
      </div>

      <div className="container max-w-6xl mx-auto px-4 sm:px-6 relative z-10 grid lg:grid-cols-2 gap-12 items-center" data-id="element-109">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center lg:text-left" data-id="element-110">
          <div className="inline-flex items-center space-x-2 bg-white/5 border border-white/10 rounded-full px-3 py-1 mb-6" data-id="element-111">
            <span className="w-2 h-2 rounded-full bg-[#FF6B35] animate-pulse" data-id="element-112"></span>
            <span className="text-xs font-medium text-gray-300 uppercase tracking-wider" data-id="element-113">
              Sistema de Productividad v2.0
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white leading-[1.1] mb-6 tracking-tight" data-id="element-114">
            DEJÁ DE POSTERGAR. <br data-id="element-115" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF6B35] to-[#FF9E7D]" data-id="element-116">
              EMPEZÁ A EJECUTAR.
            </span>
          </h1>

          <p className="text-lg sm:text-xl text-gray-400 mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-117">
            Recuperá tu enfoque en solo 21 días con un sistema visual que te
            obliga a transformarte por completo.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start mb-4" data-id="element-118">
            <a href="https://sistemaenfocado.com/cart/43851175264365:1" style={{
            display: 'block',
            textAlign: 'center',
            padding: '18px 16px',
            borderRadius: '14px',
            background: '#FF6A2A',
            color: '#111',
            fontWeight: 800,
            letterSpacing: '.06em',
            textDecoration: 'none',
            fontFamily: 'system-ui,-apple-system,Segoe UI,Roboto,Arial',
            width: '100%',
            maxWidth: '400px'
          }} data-id="element-119">
              OBTENER ACCESO INSTANTÁNEO
            </a>
            <p className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-120">
              Pago único • Acceso de por vida
            </p>
          </div>

          <p className="text-xs text-gray-500 text-center lg:text-left mb-8" data-id="element-121">
            * El precio se mostrará en tu moneda local al hacer clic
          </p>

          <div className="flex items-center justify-center lg:justify-start space-x-4 text-sm text-gray-400" data-id="element-122">
            <div className="flex -space-x-2" data-id="element-123">
              <img src="https://cdn.magicpatterns.com/uploads/jdZExdJseMNLXEQgtEB7d4/457488602_887500516589951_4601857299456230572_n.jpg" alt="Usuario enfocado" className="w-8 h-8 rounded-full border-2 border-[#0A0A0A] object-cover" data-id="element-124" />
              <img src="https://cdn.magicpatterns.com/uploads/mfafzLXr7aR78RR21qCvMZ/552637579_18371807896194664_2979012194962276787_n.jpg" alt="Usuario enfocado" className="w-8 h-8 rounded-full border-2 border-[#0A0A0A] object-cover" data-id="element-125" />
              <img src="https://cdn.magicpatterns.com/uploads/15aZPkbV9JXEC9PoeQeCQi/469954504_1649263196000310_4366962183937989050_n.jpg" alt="Usuario enfocado" className="w-8 h-8 rounded-full border-2 border-[#0A0A0A] object-cover" data-id="element-126" />
              <img src="https://cdn.magicpatterns.com/uploads/6ZZcMP76ou2szyHVecitmM/Captura_de_pantalla_2025-12-31_a_la(s)_1.44.34_p._m..png" alt="Usuario enfocado" className="w-8 h-8 rounded-full border-2 border-[#0A0A0A] object-cover" data-id="element-127" />
            </div>
            <p data-id="element-128">
              Sumate a <strong className="text-white" data-id="element-129">1.200+</strong> personas
              enfocadas
            </p>
          </div>
        </motion.div>

        {/* Hero Product Images */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-130">
          <div className="relative" data-id="element-131">
            {/* Main Product Image */}
            <motion.div whileHover={{
            scale: 1.02,
            rotate: 2
          }} transition={{
            duration: 0.3
          }} className="relative z-10" data-id="element-132">
              <img src="https://cdn.magicpatterns.com/uploads/qHqk2CH8aaoevzyCzTUUzF/pasted-image.png" alt="Plantilla Mensual Enfocado - Sistema de Hábitos" className="w-full h-auto rounded-2xl shadow-2xl border border-white/10" loading="eager" fetchPriority="high" style={{
              boxShadow: '0 0 60px rgba(255, 107, 53, 0.2), 0 20px 40px rgba(0, 0, 0, 0.4)'
            }} data-id="element-133" />
            </motion.div>

            {/* Secondary Image - Real Usage Photo */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.8,
            delay: 0.5
          }} whileHover={{
            scale: 1.05,
            rotate: -2
          }} className="absolute -bottom-8 -left-8 w-48 h-48 md:w-56 md:h-56 z-0 hidden lg:block" data-id="element-134">
              <img src="https://cdn.magicpatterns.com/uploads/xoeLNwXTv7xDquH8tvfMQJ/image.png" alt="Persona usando Enfocado" className="w-full h-full object-cover rounded-xl shadow-xl border-4 border-[#0A0A0A]" loading="lazy" style={{
              boxShadow: '0 0 40px rgba(255, 107, 53, 0.15)'
            }} data-id="element-135" />
            </motion.div>

            {/* Glow Effect */}
            <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-[#FF6B35] blur-[100px] opacity-20 pointer-events-none" data-id="element-136"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}